import React from "react";

const Page3: React.FC = () => {
  return <h1>Welcome to Page 3</h1>;
};

export default Page3;
